import React from 'react';
import cn from 'classnames';

import DropDownIcon from '../../../../assets/icons/common/DropDownIcon';
import CheckboxTickIcon from '../../../../assets/icons/common/forms/CheckboxTickIcon';
import paymentIcons from '../../../../components/common/features/PaymentItem/paymentIcons';

import styles from './styles.module.scss';

const ActivationPaymentsListItem = ({
  paymentDetails,
  clickHandler = false,
  type = 'default',
  isActive = false,
}) => {
  const Icon =
    paymentIcons[paymentDetails?.payment_details?.brand?.toLowerCase()];
  const title = `*${paymentDetails?.payment_details?.last4}`;
  const handleClick = () => {
    clickHandler(paymentDetails?.id);
  };

  return (
    <div
      onClick={handleClick}
      className={cn(styles.paymentListItem, styles[type], {
        [styles.activeDropdown]: isActive,
      })}
    >
      <div className={styles.paymentListItemLogo}>{Icon && <Icon></Icon>}</div>
      <span>{title}</span>
      {type === 'grey' && (
        <div className={styles.paymentListItemDropdownIcon}>
          <DropDownIcon></DropDownIcon>
        </div>
      )}
      {type === 'active' && <CheckboxTickIcon className={styles.tickIcon} />}
    </div>
  );
};
export default ActivationPaymentsListItem;
